import React from 'react';
import ReactDOM from 'react-dom';
import './assets/Styles/bootstrap.css';
import './assets/Styles/font.css';
import 'react-responsive-modal/styles.css';
import './assets/Styles/styles.css';
import './assets/Styles/fontawesome.css';
import 'react-notifications-component/dist/theme.css';
import App from './App';
import ReactNotification from 'react-notifications-component';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import './services/i18n';

ReactDOM.render(
    <BrowserRouter>
        <ReactNotification/>
        <App/>
    </BrowserRouter>,
    document.getElementById('root')
);

reportWebVitals();
